import * as tslib_1 from "tslib";
import dashboardApi from '@/services/dashboard';
import { getState } from '@@/store';
import { useAntdTable } from 'ahooks';
import { Table } from 'antd';
import React from 'react';
import styled from 'styled-components';
const Root = styled.div ``;
const APP_TYPE = {
    1: '后端',
    2: '前端',
    3: 'APP',
    4: 'RN热修复',
    5: '车易拍前端旧项目',
    6: '未知类型',
    7: 'SDK',
    8: '小程序',
    9: '虚拟应用',
    10: 'Web-SDK',
    11: 'SingleCode',
};
// 应用类型
const APP_TYPE_ENUMS = {
    BACK: 1,
    FRONT: 2,
    APP: 3,
    RN: 4,
    CHEYIPAI_OLD: 5,
    UN_KNOWN: 6,
    SDK: 7,
    WXMP_APP: 8,
    INVENTED: 9,
    WEB_SDK: 10,
    SingleCode: 11,
    Taro: 12,
};
const detailUrlPrefixTest = 'http://f2e.dasouche-inc.net/projects/data-fe/cybertron-pipeline-web/#/home/';
const detailUrlPrefixPro = 'https://f2e-assets.souche-inc.com/projects/data-fe/cybertron-pipeline-web/#/home/';
const MyApplication = ({ className, style }) => {
    const columns = [
        {
            title: 'appCode',
            dataIndex: 'appCode',
            width: '24%',
        },
        {
            title: '应用名称',
            dataIndex: 'appName',
            width: '24%',
        },
        {
            title: '应用区',
            dataIndex: 'appZone',
            width: '10%',
            render: (text) => text,
        },
        {
            title: '应用类型',
            dataIndex: 'appType',
            width: '12%',
            render: (text) => APP_TYPE[text],
        },
        {
            title: '负责人',
            width: '12%',
            dataIndex: 'appPersonInCharge',
        },
        {
            title: '操作',
            dataIndex: 'id',
            width: '12%',
            render: (text, record) => {
                return (<a onClick={() => {
                    const urlPrefix = process.env.MUJI_APP_ENV === 'prod'
                        ? detailUrlPrefixPro
                        : detailUrlPrefixTest;
                    switch (record.appType) {
                        case APP_TYPE_ENUMS.BACK:
                        case APP_TYPE_ENUMS.INVENTED:
                        case APP_TYPE_ENUMS.UN_KNOWN:
                            window.open(`${urlPrefix}${record.appId}/info`);
                            break;
                        case APP_TYPE_ENUMS.SingleCode:
                            window.open(`${urlPrefix}singleCode?appCode=${record.appCode}&appZone=${record.appZone}`);
                            break;
                        case APP_TYPE_ENUMS.FRONT:
                        case APP_TYPE_ENUMS.APP:
                        case APP_TYPE_ENUMS.RN:
                        case APP_TYPE_ENUMS.WXMP_APP:
                        case APP_TYPE_ENUMS.SDK:
                        case APP_TYPE_ENUMS.WEB_SDK:
                        case APP_TYPE_ENUMS.Taro:
                            window.open(`${urlPrefix}${record.appId}/wireless`);
                            break;
                        default:
                            break;
                    }
                }}>
            查看详情
          </a>);
            },
        },
    ];
    const getMyAppPage = (params) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        return yield dashboardApi.fetchMyApp({
            pageIndex: params.current,
            pageSize: params.pageSize,
            userId: getState().global.sso.userInfo.email,
            appStatus: 'online',
        }).promise;
    });
    const { tableProps } = useAntdTable(getMyAppPage, {
        defaultPageSize: 10,
        formatResult: (res) => {
            return {
                total: res.totalNumber,
                list: res.items,
            };
        },
    });
    return (<Root className={className} style={style}>
      <Table columns={columns} {...tableProps} scroll={{ y: 300 }} rowKey={'id'}/>
    </Root>);
};
export default MyApplication;
